export default __webpack_public_path__ + "static/media/heroTextLogo.165cb77f.png";